define('contact_us_register_link_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('contact_us_register_link_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/SC/ContactUsLeadFormExtension/1.1.1/', 'extensions/SC/ContactUsLeadFormExtension/1.1.1/', Handlebars);
});